module.exports = __webpack_public_path__ + "static/images/97eedf4c47a5e7a9e8035f2bc0b40eaf.webp";